import React, { useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Benefits from '../components/Benefits';
import Pricing from '../components/Pricing';
import Gallery from '../components/Gallery';
import FAQ from '../components/FAQ';
import Atmosphere from '../components/Atmosphere';
import Reviews from '../components/Reviews';
import Footer from '../components/Footer';
import AOS from 'aos';
import MessengerButton from '../components/MessengerButton';

function App() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Benefits />
        <Pricing />
        <Gallery />
        <FAQ />
        <Atmosphere />
        <Reviews />
      </main>
      <Footer />
      <MessengerButton />
    </>
  );
}

export default App; 